import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.INIT = function (state, payload) {
  state.rows = payload
}
mutations.ADD_TO_CART = function (state, payload) {
  let cart = JSON.parse(localStorage.getItem('fs_cart')) || []
  let existItem = cart.filter(x => x.id === payload.id)
  let existItemColor = cart.filter(x => x.id === payload.id && x.color === payload.color)
  let sumExistItem = 0
  let success = false

  existItem.forEach(x => {
    sumExistItem += x.quantity
  })

  if (!SysUtils.isEmpty(existItem) && SysUtils.isEmpty(existItemColor) && !payload.color) { // if same item exist with no color
    if (parseInt(payload.quantity) + sumExistItem > payload.stock_qty) {
      SysUtils.showError('Quantity exceeded stock quantity, some might already in cart!')
      return
    } else {
      cart.forEach(x => {
        if (x.id === payload.id) {
          x.quantity += parseInt(payload.quantity)
        }
      })
      success = true
    }
  } else if (!SysUtils.isEmpty(existItem) && SysUtils.isEmpty(existItemColor) && payload.color) { // if same item with diff color exist
    if (parseInt(payload.quantity) + sumExistItem > payload.stock_qty) {
      SysUtils.showError('Quantity exceeded stock quantity, some might already in cart!')
      return
    } else {
      cart.push(payload)
      success = true
    }
  } else if (!SysUtils.isEmpty(existItem) && !SysUtils.isEmpty(existItemColor)) { // if same item same color exist
    if (parseInt(payload.quantity) + sumExistItem > payload.stock_qty) {
      SysUtils.showError('Quantity exceeded stock quantity, some might already in cart!')
      return
    } else {
      cart.forEach(x => {
        if (x.id === payload.id && x.color === payload.color) {
          x.quantity += parseInt(payload.quantity)
        }
      })
      success = true
    }
  } else {
    cart.push(payload)
    success = true
  }

  if (success) SysUtils.showToasted('Item added to cart!', 'dark')

  localStorage.setItem('fs_cart', JSON.stringify(cart))
  state.rows = cart
}
mutations.DO_REMOVE = function (state, payload) {
  // let rows = state.rows.filter(x => x.id !== payload.id)
  let rows = state.rows
  let index = rows.indexOf(payload)
  rows.splice(index, 1)
  state.rows = rows
  localStorage.setItem('fs_cart', JSON.stringify(rows))
  SysUtils.showToasted('Item removed from cart!', 'dark')
}
mutations.SAVE_PAYMENT = function (state, payload) {
  localStorage.removeItem('fs_cart')
  state.rows = []
}
mutations.FIND_DETAIL = function (state, payload) {
  state.purchase_row = payload.row
  state.purchase_detail = payload.detail
}
mutations.CLEAR_ALL = function (state, payload) {
  state.purchase_row = {}
  state.purchase_detail = []
}

const state = {
  rows: localStorage.getItem('fs_cart') === null ? [] : JSON.parse(localStorage.getItem('fs_cart')),
  row: {},
  condition: {},
  purchase_row: {},
  purchase_detail: []
}
const actions = {
  init: ({ commit, state }) => {
    let cart = JSON.parse(localStorage.getItem('fs_cart'))
    if (!SysUtils.isEmpty(cart)) commit('INIT', cart)
  },
  addToCart: ({ commit, state }, condition) => {
    console.debug('called P0101ProductService search')
    return client.postData({ data: { addToCart: { api: 'P0101ProductService.addToCart', input: condition } } })
      .then((data) => {
        commit('ADD_TO_CART', data.addToCart.output)
      })
  },
  doRemove: ({ commit, state }, row) => {
    commit('DO_REMOVE', row)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { search: { api: 'M0002LandingPageService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  doSearchDetail: ({ commit, state }, condition) => {
    return client.postData({ data: { doSearchDetail: { api: 'P0201PurchaseService.doSearchDetail', input: condition } }
    })
      .then((data) => {
        if (!SysUtils.isEmpty(data.doSearchDetail.output.row) || !SysUtils.isEmpty(data.doSearchDetail.output.detail)) commit('FIND_DETAIL', data.doSearchDetail.output)
        else SysUtils.showError('Session expired!')
      })
  },
  doSavePayment: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { doSavePayment: { api: 'P0201PurchaseService.doSave', input: condition } } })
      .then((data) => {
        SysUtils.showToasted('Payment successful!', 'dark')
        commit('SAVE_PAYMENT')
      })
  },
  doUpdateStatus: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { doUpdateStatus: { api: 'P0201PurchaseService.saveData', input: condition } } })
      .then((data) => {
        SysUtils.showToasted('Status Updated! Please come again!', 'dark')
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
